import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import Meta from "../common/Meta";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Footer from "../Footer";
import {
  deleteFormQuestion,
  getCompanyForms,
  getCompanyQuestions,
  removeCompanyForm,
  saveCompanyForm,
  saveFormQuestion,
} from "../common/api/WebApi";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import Card from "@mui/material/Card";
import MDButton from "../../components/MDButton";
import {useNavigate} from "react-router-dom";
import Icon from "@mui/material/Icon";
import NotificationItem from "../Items/NotificationItem";
import Menu from "@mui/material/Menu";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import Grid from "@mui/material/Grid";
import ManageQuestionForm from "../form/ManageQuestionForm";
import MDInput from "../../components/MDInput";
import {Col, Row} from "react-bootstrap";
import {DesktopDatePicker, DesktopDateTimePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {useForm} from "react-hook-form";
import {handleDefaultValues} from "../common/Utils";
import Confirm from "../common/Confirm";

export default function CompanyForms(props) {

  const navigate = useNavigate();

  const [context, setContext] = useContext(AppContext);

  const [saving, setSaving] = useState(false);
  const [forms, setForms] = useState();
  const [questions, setQuestions] = useState();

  const getFormsFn = async () => {
    getCompanyForms().then((resp) => {
      setForms(resp);
    });
  }

  const getQuestionsFn = async () => {
    getCompanyQuestions().then((resp) => {
      setQuestions(resp);
    });
  }

  const saveForm = async (formData) => {

    setSaving(true);

    let _formData = {...formData};
    _formData.questions = [...formQuestions];

    saveCompanyForm(_formData).then((resp) => {

      let formGuid = resp.formGuid;
      getCompanyForms().then((resp) => {
        setForms(resp);
        resp.filter(x => x.formGuid === formGuid).map((ff, idx)=>{
          setForm(ff);
        })

        let _context = {...context};
        _context.reloadCart = true;
        _context.toast = {
          message: 'Form Saved',
          type: 'success'
        }
        setContext({..._context});

        setSaving(false);
      });
    });
  }

  const saveQuestion = async (question) => {
    saveFormQuestion(question).then(() => {
      getQuestionsFn();
      setSaving(false);
      setManageQuestion(false);
    });
  }

  useEffect(() => {
    getFormsFn();
    getQuestionsFn();
  }, []);

  const [form, setForm] = useState(null);
  const [manageForm, setManageForm] = useState(false);
  const [question, setQuestion] = useState(null);
  const [manageQuestion, setManageQuestion] = useState(false);

  const [renderIndex, setRenderIndex] = useState(1);
  const [formQuestions, setFormQuestions] = useState([]);

  const addQuestion = (item) => {
    let _formQuestions = [...formQuestions];
    item.sortOrder = formQuestions?.length || 0;
    let _count = _formQuestions.filter(x => x.questionGk === item.questionGk).length;
    if (_count === 0) {
      _formQuestions.push(item);
      setFormQuestions(_formQuestions);
    }
  }

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(form)
  });

  const startNewForm = () => {
    setForm({
      formName: ''
    });
    setManageForm(true);
    let _questions = [];
    setFormQuestions(_questions);
  }
  const startManageForm = (form) => {
    setForm({...form});
    setManageForm(true);
    let _questions = [...form?.questions];
    setFormQuestions(_questions);
  }

  const [confirmation, setConfirmation] = useState();
  const [confirmDeleteForm, setConfirmDeleteForm] = useState(false);
  const [confirmDeleteQuestion, setConfirmDeleteQuestion] = useState(false);

  const handleDeleteForm = (form) => {
    setSaving(true);
    removeCompanyForm(form).then(() => {
      setConfirmation(null);
      setConfirmDeleteForm(false);
      getFormsFn();
      setSaving(false);
    });
  }

  const handleDeleteQuestion = (question) => {
    setSaving(true);
    deleteFormQuestion(question).then(() => {
      setConfirmation(null);
      setConfirmDeleteQuestion(false);
      getQuestionsFn();
      getFormsFn();
      setSaving(false);
    });
  }

  const startArchiveQuestion = (question) => {
    let confirmation = {
      title: 'Delete Question?',
      message: 'Delete ' + question.questionLabel + '?',
      entity: question
    }
    setConfirmation(confirmation);
    setConfirmDeleteQuestion(true);
  }

  const startArchiveForm = (form) => {
    let confirmation = {
      title: 'Delete Form?',
      message: 'Delete ' + form.formName + '?',
      entity: form
    }
    setConfirmation(confirmation);
    setConfirmDeleteForm(true);
  }

  const FormActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'vendor-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
           <MDButton
             variant="outlined"
             color="secondary"
             size="small"
             circular
             iconOnly
           >
            <Icon>more_horiz</Icon>
          </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                startManageForm(item)
              }} icon={<Icon>person</Icon>} title="Manage"/>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                startArchiveForm(item)
              }} icon={<Icon>delete</Icon>} title="Delete"/>

          </Menu>
        </>
      )}
    </PopupState>);
  }

  const removeFormQuestion = (q, idx) => {
    let _formQuestions = [...formQuestions];
    let kk;
    for (let k in _formQuestions) {
      if (_formQuestions[k].questionGk === q.questionGk) {
        kk = k;
      }
    }
    _formQuestions.splice(kk, 1);
    setFormQuestions([..._formQuestions]);
  }

  const QuestionActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'vendor-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
           <MDButton
             variant="outlined"
             color="secondary"
             size="small"
             circular
             iconOnly
           >
            <Icon>more_horiz</Icon>
          </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              disabled={!manageForm}
              onClick={(e) => {
                popupState.close();
                addQuestion(item);
              }} icon={<Icon>add</Icon>} title="Add to form"/>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                setQuestion(item);
                setManageQuestion(true);
              }} icon={<Icon>person</Icon>} title="Manage"/>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                startArchiveQuestion(item)
              }} icon={<Icon>delete</Icon>} title="Archive"/>

          </Menu>
        </>
      )}
    </PopupState>);
  }

  const moveUp = (item) => {
    let _obj = [...formQuestions];
    for (let i = 0; i < _obj.length; i++) {
      _obj[i].sortOrder = i;
    }
    for (let i = 0; i < _obj.length; i++) {
      if (_obj[i].questionGk === item.questionGk) {
        _obj[i].sortOrder = _obj[i].sortOrder - 1;
      } else {
        _obj[i].sortOrder = _obj[i].sortOrder + 1;
      }
    }
    setFormQuestions([..._obj]);
    setRenderIndex(renderIndex + 1);
  }

  const moveDown = (item) => {
    let _obj = [...formQuestions];
    for (let i = 0; i < _obj.length; i++) {
      _obj[i].sortOrder = i;
    }
    for (let i = 0; i < _obj.length; i++) {
      if (_obj[i].questionGk === item.questionGk) {
        _obj[i].sortOrder = _obj[i].sortOrder + 1;
      } else {
        _obj[i].sortOrder = _obj[i].sortOrder - 1;
      }
    }
    setFormQuestions([..._obj]);
    setRenderIndex(renderIndex + 1);
  }

  const displayQuestion = (item) => {
    if (item.questionType.id === 1) {
      return <>
        <label>{item.questionLabel}</label>
        <input type={"text"} className={'form-control'}
               disabled
               required={item.required}
               placeholder={item.description}/></>
    }
    if (item.questionType.id === 2) {
      return <>
        <label>{item.questionLabel}</label>
        <textarea disabled className={'form-control'} required={item.required}
                  placeholder={item.description}/></>
    }

    if (item.questionType.id === 3) {
      return <>
        <label><input disabled type="checkbox"
                      role={'switch'}
                      id="reminderNote"
                      className={'form-check-input'}
                      required={item.required}
        />&nbsp;{item.questionLabel}</label>
        <p><small>{item.description}</small></p>
      </>
    }

    if (item.questionType.id === 4) {
      return <div className={'col col-sm-12 col-md-12 col-lg-9'}>
        <label htmlFor="state">{item.questionLabel}</label>
        <input type={"number"} className={'form-control'}
               disabled
               {...register(`answer.${item.questionGuid}`)}
               required={item.required}
               placeholder={item.description}/></div>
    }

    if (item.questionType.id === 5) {
      return <>
        <div className="form-group">
          <label htmlFor="billingEndDate">{item.questionLabel}</label>
          <div>
            <DesktopDatePicker disabled
                        slotProps={{
                          actionBar: {
                            actions: ['today'],
                          },
                        }}
                        value={dayjs(new Date())}
                        onChange={(e) => {

                        }}
            />
          </div>
        </div>
      </>
    }

    if (item.questionType.id === 6) {
      return <>
        <div className="form-group">
          <label htmlFor="billingEndDate">{item.questionLabel}</label>
          <div>
            <DesktopDateTimePicker disabled
                            slotProps={{
                              actionBar: {
                                actions: ['today'],
                              },
                            }}
                            value={dayjs(new Date())}
                            onChange={(e) => {

                            }}
            />
          </div>
        </div>
      </>
    }

    if (item.questionType.id === 7) {
      return <>
        <div className="form-group">
          <h5 htmlFor="billingEndDate">{item.questionLabel}</h5>
          <div>
            <p style={{
              whiteSpace: 'pre-wrap'
            }}>{item.description}</p>
          </div>
        </div>
      </>
    }

    return <>&nbsp;</>
  }

  return (
    <DashboardLayout>

      <Meta pageTitle={'Event Forms'}/>

      <ContextSearchNavbar title={'Event Forms'}/>
      <MDBox py={3}>

        <Grid container spacing={2}>
          <Grid item sm={4}>

            <Card>
              <MDBox p={2}>
                <h5 className={'mb-3'}>
                  Questions &nbsp;
                  <MDButton
                    onClick={(e) => {
                      setQuestion(null)
                      setManageQuestion(true);
                    }}
                    color="secondary"
                    size="small"
                    className={'pull-right'}>
                    Add Question</MDButton>
                </h5>

                <table className="table table-striped mt-2">
                  <tbody>
                  {questions?.length === 0 && <>
                    <tr>
                      <td colSpan={2}>
                        <center>No Questions</center>
                      </td>
                    </tr>
                  </>}
                  {questions?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td><Icon>{item.questionType?.icon}</Icon></td>
                          <td>{item.questionLabel}
                            <span className={'pull-right'}>
                            <QuestionActions item={item}/>
                          </span>
                          </td>
                        </tr>
                      )
                    }
                  )}
                  </tbody>
                </table>

              </MDBox>
            </Card>

          </Grid>

          <Grid item sm={8}>

            <Card>
              <Row>
                <Col xs={12}>
                  <MDBox p={2}>
                    {!manageForm && <>
                      <h5>Forms <MDButton
                        onClick={(e) => {
                          startNewForm()
                        }}
                        color="secondary"
                        size="small"
                        className={'pull-right'}>
                        Add Form</MDButton>
                      </h5>
                      <table className="table table-striped mt-2">
                        <thead>
                        <tr>
                          <th scope="col">Form Name</th>
                          <th scope="col" className={'text-right'}>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {forms?.length === 0 && <>
                          <tr>
                            <td colSpan={2}>
                              <center>No Forms Found</center>
                            </td>
                          </tr>
                        </>}
                        {forms?.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td><a href={"#"} onClick={(e) => {
                                  e.preventDefault();
                                  startManageForm(item)
                                }}>{item.formName}</a>
                                </td>
                                <td>
                              <span className={'pull-right'}>
                              <FormActions item={item}/>
                            </span>
                                </td>
                              </tr>
                            )
                          }
                        )}
                        </tbody>
                      </table>
                    </>}

                    {manageForm && form && <>

                      <form>
                        <h4>Manage Form

                          <a href={"#"} className={'pull-right cursor-pointer'}
                             style={{
                               color: "#ccc"
                             }}
                             onClick={(e) => {
                               e.preventDefault();
                               setManageForm(false);
                             }}><span className={"fa fa-times"}></span> </a>
                        </h4>
                        <h5><MDInput type="text" required
                                     autoComplete="off"
                                     variant="outlined"
                                     InputLabelProps={{shrink: true}}
                                     {...register('formName',
                                       {
                                         required: true
                                       })}
                                     placeholder={"Form Name"}
                                     className="form-control" id="formName"
                                     label="Form name"/>
                        </h5>

                        <div style={{
                          border: 'solid 1px #ddd',
                          display: 'block',
                          width: '100%',
                          minHeight: '200px'
                        }}>
                          {!formQuestions?.length && <>
                            <center><small>Add questions to form</small></center>
                          </>}
                          {formQuestions?.length > 0 && <>

                            <table className="table">
                              <tbody>
                              {renderIndex && formQuestions?.sort((a, b) => a.sortOrder - b.sortOrder).map((q, index) => {
                                return (
                                  <tr key={index}>

                                    <td width={"5%"}>
                                      <MDButton color="primary"
                                                disabled={index === 0}
                                                className="pull-right d-block clear clearfix mx-1"
                                                size="small"
                                                onClick={() => {
                                                  moveUp(q);
                                                }}>
                                                       <span
                                                         style={{
                                                           fontSize: '16px'
                                                         }}
                                                         className={'fa fa-arrow-circle-up'}></span>
                                      </MDButton>

                                      <div style={{
                                        width: '100%',
                                        clear: 'both',
                                        height: '4px',
                                        display: 'block'
                                      }}></div>
                                      <MDButton color="primary"
                                                disabled={index === formQuestions.length - 1}
                                                className="pull-right d-block clear clearfix mx-1"
                                                size="small"
                                                onClick={() => {
                                                  moveDown(q);
                                                }}>
                                              <span
                                                style={{
                                                  fontSize: '16px'
                                                }}
                                                className={'fa fa-arrow-circle-down'}></span>
                                      </MDButton>


                                    </td>
                                    <td>
                                      {displayQuestion(q)}
                                    </td>

                                    <td width={"2%"}>
                                      <a href={"#"} className={'cursor-pointer'}
                                         style={{
                                           color: "#ccc"
                                         }}
                                         onClick={(e) => {
                                           e.preventDefault();
                                           removeFormQuestion(q, index)
                                         }}><span className={"fa fa-times"}></span> </a>
                                    </td>
                                  </tr>
                                )
                              })
                              }
                              </tbody>
                            </table>
                          </>
                          }

                        </div>

                        <MDButton
                          color="info"
                          size="small"
                          onClick={handleSubmit(saveForm)}
                          className={'btn btn-primary my-2 pull-right'}
                        >Save
                        </MDButton>
                      </form>
                    </>
                    }

                  </MDBox>
                </Col>
              </Row>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/*{manageForm && <>*/}

      {/*</>}*/}

      {/*{manageForm && <ManageEventForm*/}
      {/*  form={form}*/}
      {/*  show={manageForm}*/}
      {/*  saving={saving}*/}
      {/*  handleSave={(e) => {*/}
      {/*    console.dir(e)*/}
      {/*    setSaving(true);*/}
      {/*    saveForm(e)*/}
      {/*  }}*/}
      {/*  handleClose={(e) => {*/}
      {/*    setManageForm(false);*/}
      {/*  }}/>*/}
      {/*}*/}

      {manageQuestion && <ManageQuestionForm
        question={question}
        show={manageQuestion}
        saving={saving}
        handleSave={(e) => {
          setSaving(true);
          saveQuestion(e).then(() => {
            setManageQuestion(false);
            getFormsFn();
          })
        }}
        handleClose={(e) => {
          setManageQuestion(false);
        }}/>
      }

      {confirmDeleteForm && <Confirm confirmation={confirmation}
                                 show={confirmDeleteForm}
                                 saving={saving}
                                 handleConfirm={handleDeleteForm}
                                 handleSave={() => {
                                   setConfirmDeleteForm(false);
                                 }}/>}

      {confirmDeleteQuestion && <Confirm confirmation={confirmation}
                                     show={confirmDeleteQuestion}
                                     saving={saving}
                                     handleConfirm={handleDeleteQuestion}
                                     handleSave={() => {
                                       setConfirmDeleteQuestion(false);
                                     }}/>}

      {/*  </>*/}
      {/*}*/}

      <Footer mt={5}/>

    </DashboardLayout>
  );
}